import React, { Component } from "react";
import Footer from "../Footer";
import "../styles/HomePage.scss";

export default class HomePage extends Component{
    render() {
        return <div className={"homepage-container"}>
                <div className={"left"}>
                    <h1>Sign Up</h1>
                    <h3>Welcome to Telos! Make outdoor media planning faster and easier.</h3>
                    <h5>
                        Sign in with <b>Google</b> or <b>Microsoft</b> to set up your account
                    </h5>
                    <a href={process.env.REACT_APP_BACKEND_URL+"/go-to-google-sign-in"} className={"sign-up-btn"}>
                        <img src={"https://app.trylavender.com/public/img/sign-in/GoogleBadge.png"} alt={"google sign in"}/>
                    </a>
                    {/*<a href={process.env.REACT_APP_BACKEND_URL+"/go-to-microsoft-sign-in"} className={"sign-up-btn"}>*/}
                    {/*    <img src={"https://app.trylavender.com/public/img/sign-in/MicrosoftBadge.png"} alt={"microsoft sign in"}/>*/}
                    {/*</a>*/}
                    <hr/>
                    <h2>Already have an account?</h2>
                    <div className={"login-btns"}>
                        <a href={process.env.REACT_APP_BACKEND_URL+"/go-to-google-sign-in"} className={"login-btn"}>
                            <img src={"https://app.trylavender.com/public/img/sign-in/GoogleBadge.png"} alt={"google sign in"}/>
                        </a>
                        {/*<a href={process.env.REACT_APP_BACKEND_URL+"/go-to-microsoft-sign-in"} className={"login-btn"}>*/}
                        {/*    <img src={"https://app.trylavender.com/public/img/sign-in/MicrosoftBadge.png"} alt={"microsoft sign in"}/>*/}
                        {/*</a>*/}
                    </div>
                    <Footer/>
                </div>
            <div className={"right"}>
                <h1><div className={"circle-logo"}/> Telos</h1>
            </div>
        </div>;
    }
}
